const moneyCurrency = [
  {label: 'USD', value: 'usd', sign: '$'},
  {label: 'EUR', value: 'eur', sign: '€'},
  {label: 'PNL', value: 'pnl', sign: 'zł'},
];

export {moneyCurrency};
